import {
  ActivityIcon,
  BeakerIcon,
  ClockIcon,
  FileTextIcon,
  UsersIcon,
} from "lucide-react";

import { JobBottleneckBadge } from "@/components/job-tracker/badges/JobBottleneckBadge";
import { JobHealthBadge } from "@/components/job-tracker/badges/JobHealthBadge";
import { Row, TableTooltipParagraph, TimeAgoInTableCell } from "@/components";
import { Badge } from "@/components/ui/badge";
import {
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import { useTaggableUsers } from "@/contexts/TaggableUsersContext";
import { JobUpdate } from "@/types";

export const JobUpdateHistory = ({
  jobUpdates,
}: {
  jobUpdates: JobUpdate[];
}) => {
  /* Misc Hooks */
  const { userNameMap } = useTaggableUsers();

  const render = () => {
    return (
      <div className="relative h-full overflow-auto rounded-lg border border-slate-200">
        <table className="w-full table-fixed text-sm">
          <TableHeader className="sticky top-0 bg-slate-50 [&_tr]:border-b-0">
            <TableRow className="sticky-border-bottom">
              <TableHead className="w-[12%]">
                <Row className="items-center gap-2 text-slate-700">
                  <BeakerIcon className="h-4 w-4" />
                  Bottleneck
                </Row>
              </TableHead>
              <TableHead className="w-[12%]">
                <Row className="items-center gap-2 text-slate-700">
                  <ActivityIcon className="h-4 w-4" />
                  Health
                </Row>
              </TableHead>
              <TableHead className="w-[43%]">
                <Row className="items-center gap-2 text-slate-700">
                  <FileTextIcon className="h-4 w-4" />
                  Description
                </Row>
              </TableHead>
              <TableHead className="w-[16%]">
                <Row className="items-center gap-2 text-slate-700">
                  <ClockIcon className="h-4 w-4" />
                  Created At
                </Row>
              </TableHead>
              <TableHead className="w-[17%]">
                <Row className="items-center gap-2 text-slate-700">
                  <UsersIcon className="h-4 w-4" />
                  Created By
                </Row>
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {jobUpdates.map((update) => {
              return (
                <TableRow key={update.id}>
                  <TableCell className="px-2">
                    {update.bottleneck != null ? (
                      <JobBottleneckBadge bottleneck={update.bottleneck} />
                    ) : null}
                  </TableCell>
                  <TableCell className="px-2">
                    {update.health != null ? (
                      <JobHealthBadge health={update.health} />
                    ) : null}
                  </TableCell>
                  <TableCell>
                    <TableTooltipParagraph text={update.description ?? ""} />
                  </TableCell>
                  <TableCell>
                    <TimeAgoInTableCell timestamp={update.createdAt} />
                  </TableCell>
                  <TableCell>
                    <Badge className="max-w-full" variant="secondary">
                      <TableTooltipParagraph
                        text={userNameMap[update.userId] ?? "Unknown"}
                      />
                    </Badge>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </table>
      </div>
    );
  };

  return render();
};
